
import { isValidDate, dateFormat, isParalympic } from "helpers/utils"
import { findArray, findParticResult, filterArray } from 'helpers/utils'
import { completeRsc, getDisciplineRSC, getEventRSC, RSC_EMPTY } from 'helpers/rsc';
import { useParams } from "react-router-dom"
import { useQuery } from 'react-query'
import { getConfigData, mergeCurrentExtendedResults } from "data/configs"
import { isFinishedStatus } from "helpers/status";
import { useGetConfigSports } from "helpers/commonCodes";


export const fetchData = async (_url, coomitError = true) => {
	if (_url !== undefined) {
		const controller = new AbortController();
		try {

			const response = await fetch(_url, {
				//  signal: controller.signal
			});

			if (!response.ok) {
				const message = `An error has occured About Page: ${response.status}`;
				console.log("ERROR:" + message)
				//throw new Error(message);
			}

			const json = await response.json();
			controller.abort();
			return json;

		} catch (error) {
			//No connection with server         

			controller.abort();
			if (coomitError) { throw new Error('MIRS ERROR CONECTION ' + _url); }
			/*
			return (
					{
							loggerMirs: `Error connection: ${error}`
					}
			)
			*/
		}
	} else {
		return undefined
	}
}

export const fetchDataJSON = async (_url) => {
	const response = await fetch(_url);
	//const json = await response.json();
	//return json;
	return response.json();
}



export const getScheduleData = async ({ queryKey }) => {
	const [_key, _competition, _language, _discipline, _date, _event, _isH2H] = queryKey

	let query = "SCH_ByDisciplineRUN" //default run 

	if (_isH2H) {
		query = "SCH_ByDisciplineH2H"
	}

	//RUN 
	const url = isValidDate(_date) ?
		`${process.env.REACT_APP_SERVER_URL}/${query}~comp=${_competition}~disc=${_discipline}~lang=${_language}~date=${_date}.json`
		:
		`${process.env.REACT_APP_SERVER_URL}/${query}~comp=${_competition}~disc=${_discipline}~lang=${_language}.json`

	//H2H



	const scheduleLines = await fetchData(url);

	let result = [];
	if (scheduleLines && scheduleLines.schedules) {
		/* SORT DATA*/
		result = scheduleLines.schedules.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
		/* FILTER DATA
		isValidDate(_date) ?
			result = result !== undefined ? result.filter(row => dateFormat(row.startDate) === _date) : []
			: result = result !== undefined ? result : []

		if (_event !== undefined) {
			result = result?.filter(row => row?.eventUnit?.phase?.event?.code === _event)
		}*/
	}
	return result

}

export const getScheduleDays = async ({ queryKey }) => {
	const [_key, _competition, _language, _discipline] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/SCH_DaysByDiscipline~comp=${_competition}~disc=${_discipline}~lang=${_language}.json`
	const data = await fetchData(url);
	return data;
}

export const getScheduleMainGrid = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	let url = `${process.env.REACT_APP_SERVER_URL}/SCH_MainGrid~comp=${_competition}~lang=${_language}.json`
	const data = await fetchData(url);
	return data;
}

export const getResultRSC_H2H = async ({ queryKey }) => {
	const [_key, _competition, _rsc, _language] = queryKey
	const _disc = getDisciplineRSC(_rsc);
	const url = `${process.env.REACT_APP_SERVER_URL}/RES_ByRSC_H2H~comp=${_competition}~disc=${_disc}~rscResult=${_rsc}~lang=${_language}.json`
	const data = await fetchData(url);

	//sort actions
	data?.results?.playByPlay?.forEach(item => item?.actions?.sort((a, b) => b.pbpa_order - a.pbpa_order));

	//sort referees
	data?.results?.officials?.sort((a, b) => a.order - b.order);

	//sort coaches
	data?.results?.items?.forEach(item => item?.teamCoaches?.sort((a, b) => a.order - b.order));

	//sort athletes
	data?.results?.items?.forEach(item => item?.teamAthletes?.sort((a, b) => a.order - b.order));

	//add position description to each team member
	data?.results?.items?.forEach(
		item => item.teamAthletes?.map(ath => {
			const position = ath?.eventUnitEntries?.find(eue => eue.eue_code === 'POSITION')?.eue_value;
			const description = data?.positions?.find(item => item.code === position)?.description;
			const code = data?.positions?.find(item => item.code === position)?.code;
			return ath.functionDescription = description, ath.functionCode = code;
		}
		)
	)

	// add home away objects as a way to paint periods and resolve teams and athletes names
	let home = {}
	let away = {}

	if (data?.results?.items) {
		let homeRaw = data?.results?.items?.find(item =>
			item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'HOME')
		)
		// there is NO event unit entry HOME_AWAY, then guess that HOME is the one's with startSortOrder = 1
		if (homeRaw === undefined) {
			homeRaw = data?.results?.items?.find(item => item.startSortOrder === 1)
		}
		if (homeRaw === undefined) {
			homeRaw = data?.results?.items?.find(item => item.sortOrder === 1)
		}
		home.extendedResults = homeRaw?.extendedResults;
		home.participant = homeRaw?.participant;
		home.teamAthletes = homeRaw?.teamAthletes;
		home.resultType = homeRaw?.resultType;
		home.resultData = homeRaw?.resultData;
		home.resultDataText = homeRaw?.resultDataText;
		home.resultWLT = homeRaw?.resultWLT;
		home.sortOrder = homeRaw?.sortOrder;

		let awayRaw = data?.results?.items?.find(item =>
			item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'AWAY')
		)
		// there is NO event unit entry HOME_AWAY, then guess that AWAY is the one's with startSortOrder = 2
		if (awayRaw === undefined) {
			awayRaw = data?.results?.items?.find(item => item.startSortOrder === 2)
		}
		if (awayRaw === undefined) {
			awayRaw = data?.results?.items?.find(item => item.sortOrder === 2)
		}
		away.extendedResults = awayRaw?.extendedResults;
		away.participant = awayRaw?.participant;
		away.teamAthletes = awayRaw?.teamAthletes;
		away.resultType = awayRaw?.resultType;
		away.resultData = awayRaw?.resultData;
		away.resultDataText = awayRaw?.resultDataText;
		away.resultWLT = awayRaw?.resultWLT;
		away.sortOrder = awayRaw?.sortOrder;
	}

	if (data?.results) {
		data.results.home = home;
		data.results.away = away;
	}

	return data;
}

export const getResultsPhase = async ({ queryKey }) => {
	const [_key, _competition, _rsc, _language, _rscConfig] = queryKey
	const rscCfg = (_rscConfig === undefined) ? _rsc + RSC_EMPTY.UNIT : _rscConfig  // if null use rsc
	const fullRsc = completeRsc(_rsc)
	const url = `${process.env.REACT_APP_SERVER_URL}/RES_Phase~comp=${_competition}~rsc=${fullRsc}~rscConfig=${rscCfg}~lang=${_language}.json`
	const data = await fetchData(url);
	return data
}

export const getResultsRSC = async ({ queryKey }) => {
	const [_key, _competition, _rsc, _language, _rscConfig, subcode, recordTypes, _rscImages, recordEvent] = queryKey
	const _disc = getDisciplineRSC(_rsc);
	const _event = recordEvent ? recordEvent : getEventRSC(_rsc);

	const defaultRecord = isParalympic(_competition) ? process.env.REACT_APP_RECORDS_PARAS.split(",") : process.env['REACT_APP_RECORDS_'+_disc]?.split(",");

	const _recordTypes = recordTypes || defaultRecord  //TODO move to process.env.REACT_APP_RECORDS
	const rscCfg = _rscConfig ? _rscConfig : _rsc // if null use rsc
	const rscImg = _rscImages ? _rscImages : _rsc // if null use rsc

	let url = `${process.env.REACT_APP_SERVER_URL}/RES_ByRSC~comp=${_competition}~rsc=${_rsc}~disc=${_disc}~event=${_event}~recordTypes=${_recordTypes}~rscConfig=${rscCfg}~rscImages=${rscImg}~lang=${_language}.json`
	if (subcode) {
		url = `${process.env.REACT_APP_SERVER_URL}/RES_ByRSC~comp=${_competition}~rsc=${_rsc}~disc=${_disc}~event=${_event}~recordTypes=${_recordTypes}~rscConfig=${rscCfg}~rscImages=${rscImg}~lang=${_language}~subcode=${subcode}.json`
	}


	const data = await fetchData(url);
	addCurrentFinalSplit(data, _disc, _rsc)//change values passing data (by refence)




	/**--------------------------------------- */

	data?.records?.map(item => item.recordDataFiltered = filterRecordData(item.recordData, _disc, data?.results?.eventUnit?.phase?.order, data?.results?.schedule?.startDate));
	const extendedInfos = data?.results?.extendedInfos
	const items = data?.results?.items
	if (extendedInfos && items) {
		//current attemp for jumps and throws
		let currentAttempt = extendedInfos && findArray(extendedInfos, { ei_type: ['DISPLAY'], ei_code: ['INTERMEDIATE_ATTEMPT_CURRENT'] }).ei_value
		//previus and current competitor and their results data.  
		let currentCompetitor = extendedInfos && findArray(extendedInfos, { ei_type: ['DISPLAY'], ei_code: ['CURRENT'] })
		let currentCompetitorCode = currentCompetitor.ei_value
		let currentCompetitorPos = currentCompetitor.ei_pos
		let currentHeightAttempt = extendedInfos && findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['INTERMEDIATE'], ei_pos: [currentCompetitorPos] })
		let currentCompetitorResult = findParticResult(items, currentCompetitorCode);

		let previousCompetitor = extendedInfos && findArray(extendedInfos, { ei_type: ['DISPLAY'], ei_code: ['LAST_COMP'] })
		let previousCompetitorCode = previousCompetitor.ei_value
		let previousCompetitorPos = currentCompetitor.ei_pos
		let previousHeightAttempt = extendedInfos && findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['INTERMEDIATE'], ei_pos: [previousCompetitorPos] })
		let previousCompetitorResult = findParticResult(items, previousCompetitorCode);


		//adding attempt key/value to previous and current result object
		if (previousCompetitorResult) {
			previousCompetitorResult.pos = previousCompetitorPos;
			previousCompetitorResult.heightAttempt = previousHeightAttempt.ei_value;
			data.results.previousCompetitorResult = previousCompetitorResult;

		}
		if (currentCompetitorResult) {
			currentCompetitorResult.pos = currentCompetitorPos;
			currentCompetitorResult.heightAttempt = currentHeightAttempt.ei_value;
			data.results.currentCompetitorResult = currentCompetitorResult;
		}
	}
	/*-----------------------------------------------------------------*/

	//Progress Bar
	const _progress_bar = ['ATH', 'CRD', 'MTB', 'OWS', 'SWM', 'TRI', 'MPN']    // TODO move to process.env.REACT_APP_PROGRESS_BAR
	if (_progress_bar.find(item => item === _disc)) {
		data.progressBar = getConfigData(_disc, data);
	}
	const _merge_currentExtendedResults = ['CSL', 'SJP']    // TODO move to process.env.REACT_APP_PROGRESS_BAR
	if (_merge_currentExtendedResults.find(item => item === _disc)) {
		mergeCurrentExtendedResults(_disc, data?.results?.items);
	}

		// add home away objects as a way to paint periods and resolve teams and athletes names
		let home = {}
		let away = {}
	
		if (data?.results?.items) {
			let homeRaw = data?.results?.items?.find(item =>
				item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'HOME')
			)
			// there is NO event unit entry HOME_AWAY, then guess that HOME is the one's with startSortOrder = 1
			if (homeRaw === undefined) {
				homeRaw = data?.results?.items?.find(item => item.startSortOrder === 1)
			}
			if (homeRaw === undefined) {
				homeRaw = data?.results?.items?.find(item => item.sortOrder === 1)
			}
			home.extendedResults = homeRaw?.extendedResults;
			home.participant = homeRaw?.participant;
			home.teamAthletes = homeRaw?.teamAthletes;
			home.resultType = homeRaw?.resultType;
			home.resultData = homeRaw?.resultData;
			home.resultDataText = homeRaw?.resultDataText;
			home.resultWLT = homeRaw?.resultWLT;
			home.sortOrder = homeRaw?.sortOrder;
	
			let awayRaw = data?.results?.items?.find(item =>
				item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'AWAY')
			)
			// there is NO event unit entry HOME_AWAY, then guess that AWAY is the one's with startSortOrder = 2
			if (awayRaw === undefined) {
				awayRaw = data?.results?.items?.find(item => item.startSortOrder === 2)
			}
			if (awayRaw === undefined) {
				awayRaw = data?.results?.items?.find(item => item.sortOrder === 2)
			}
			away.extendedResults = awayRaw?.extendedResults;
			away.participant = awayRaw?.participant;
			away.teamAthletes = awayRaw?.teamAthletes;
			away.resultType = awayRaw?.resultType;
			away.resultData = awayRaw?.resultData;
			away.resultDataText = awayRaw?.resultDataText;
			away.resultWLT = awayRaw?.resultWLT;
			away.sortOrder = awayRaw?.sortOrder;
		}
	
		if (data?.results) {
			data.results.home = home;
			data.results.away = away;
		}
		
	return data
}

export const getTeamResultsRSC = async ({ queryKey }) => {
	const [_key, _rsc] = queryKey
	const _disc = getDisciplineRSC(_rsc);
	const url = `${process.env.REACT_APP_SERVER_URL}/PBP_ByRSC~comp=${process.env.REACT_APP_DEFAULT_COMPETITION}~disc=${_disc}~rsc=${_rsc}~lang=ENG.json`

	const data = await fetchData(url);


}

export const getConfigRSC = async ({ queryKey }) => {
	const [_key, _competition, _language, _rsc] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/CNF_ByRSC~comp=${_competition}~rsc=${_rsc}~lang=${_language}.json`
	return await fetchData(url);
}

export const getBioDetail = async ({ queryKey }) => {
	const [_key, _competition, _language, _code] = queryKey
	//const url = `${process.env.REACT_APP_SERVER_URL}/BIO_ATH_ByParticCode~comp=${_competition}~code=${_code}~lang=${_language}.json`
	const url = `${process.env.REACT_APP_SERVER_URL}/CIS_Bio_Athlete~comp=${_competition}~code=${_code}~lang=${_language}.json`
	return await fetchData(url);
}

export const getPhotoFinish = async ({ queryKey }) => {
	const [_key, _language, _rsc] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/IMG_PhotoFinish~comp=${process.env.REACT_APP_DEFAULT_COMPETITION}~rsc=${_rsc}~lang=ENG.jpg`

	return await fetchData(url);
}

const filterRecordData = (recordData, discipline, phaseOrder, starDate) => {
	let data = recordData;
	if ('|ARC|ATH|CLB|CTR|MPN|SHO|SWM|'.includes(discipline)) {
		data = recordData?.filter(item => item?.eventUnit == null || parseInt(item?.eventUnit?.phase?.order) > parseInt(phaseOrder))
	} else if ('|CSP|ROW|'.includes(discipline)) {
		data = recordData?.filter(item => item?.eventUnit == null || parseInt(item?.eventUnit?.phase?.order) >= parseInt(phaseOrder))
	} else if ('|XXX|'.includes(discipline)) {
		data = recordData?.filter(item => item?.eventUnit == null || parseInt(item?.eventUnit?.schedule?.endDate) < starDate)
	}
	return data && '|SWM|'.includes(discipline) ? data : data ? data.slice(-1) : []
}

export const getDisciplines = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Disciplines~comp=${_competition}~lang=${_language}.json`
	return await fetchData(url);

}

export const getEvents = async ({ queryKey }) => {
	const [_key, _competition, _language, _discipline] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/SEL_Events~comp=${_competition}~disc=${_discipline}~lang=${_language}.json`
	return await fetchData(url);


}

export const getPhases = async ({ queryKey }) => {
	const [_key, _competition, _language, _event] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/SEL_Phases~comp=${_competition}~lang=${_language}~event=${_event}.json`
	const data = await fetchData(url);
	const dataFilter = data?.event?.phases?.filter(item => item.type === '3');
	return dataFilter;

}

export const getUnits = async ({ queryKey }) => {
	const [_key, _competition, _language, _phase, scheduled, haveSchedule] = queryKey
	const _scheduled = (scheduled === undefined) ? 'Y' : scheduled  // if null use Y
	const _haveSchedule = (haveSchedule === undefined) ? 'true' : haveSchedule  // if null use true
	const url = `${process.env.REACT_APP_SERVER_URL}/SEL_Units~comp=${_competition}~lang=${_language}~phase=${_phase}~scheduled=${_scheduled}~haveSchedule=${_haveSchedule}.json`
	return await fetchData(url);
}

export const getAllGames = async ({ queryKey }) => {
	const [_key, _competition, _discipline, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_AllGames~comp=${_competition}~disc=${_discipline}~lang=${_language}.json`
	return await fetchData(url);
}

export const getEventGames = async ({ queryKey }) => {
	const [_key, _competition, _event, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_EventGames~comp=${_competition}~event=${_event}~lang=${_language}.json`
	return await fetchData(url);
}


export const getConfigCompetitions = async ({ queryKey }) => {
	const [_key, mirs_competition] = queryKey;
	const url = `/assets/configuration/competitions.json`;
	const data = await fetchData(url);
	data?.competition?.find(item => item?.competitionCode === mirs_competition);

	return data;
}

export const getConfigSports = async ({ queryKey }) => {
	const [_key, mirs_competition, mirs_discipline] = queryKey;
	const url = `/assets/configuration/${mirs_competition}/${mirs_discipline}.json`;
	return await fetchData(url, false);
}

export const getPoolStanding = async ({ queryKey }) => {
	const [_key, _competition, _rsc, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_PoolStandings~comp=${_competition}~rsc=${_rsc}~lang=${_language}.json`
	return await fetchData(url);
}

export const getBracket = async ({ queryKey }) => {
	const [_key, _competition, _rsc, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Bracket~comp=${_competition}~rsc=${_rsc}~lang=${_language}.json`
	return await fetchData(url);
}

export const getEventRanking = async ({ queryKey }) => {
	const [_key, _competition, _rsc, _language] = queryKey
	const rscModified = getEventRSC(_rsc);
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_EventRanking~comp=${_competition}~event=${rscModified}~lang=${_language}.json`
	return await fetchData(url);
}

export const getSportsCodes = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_SportCodes~comp=${_competition}~lang=${_language}.json`
	return await fetchData(url);
}

export const getLanguages = async () => {
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Languages.json`
	return await fetchData(url);
}

export const getCompetitions = async ({ queryKey }) => {
	const [_key, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Competitions~lang=${_language?.toUpperCase()}.json`
	return await fetchData(url);
}

export const getEventUnits = async ({ queryKey }) => {
	const [_key, _competition, _discipline, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_EventUnits~comp=${_competition}~disc=${_discipline}~lang=${_language?.toUpperCase()}.json`
	return await fetchData(url);
}

export const getPositions = async ({ queryKey }) => {
	const [_key, _competition, _discipline, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Positions~comp=${_competition}~disc=${_discipline}~lang=${_language?.toUpperCase()}.json`
	return await fetchData(url);
}

export const getRoutes = async ({ queryKey }) => {
	const [_key, { router_language, competition }] = queryKey;
	const url = `/assets/routes/${router_language.toLowerCase()}/routes.json`;
	return await fetchData(url);
}

export const getNocs = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/MIS_NOCS~comp=${_competition}~lang=${_language?.toUpperCase()}.json`
	return await fetchData(url);
}


export const getAlerts = async ({ queryKey }) => {
	const [_key, _competition, _discipline, _type] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/CIS_Ticker~comp=${_competition}~disc=${_discipline}~type=${_type?.toUpperCase()}.json`
	return await fetchData(url);
}

export const useSportsCodes = () => {
	const { mirs_competition, mirs_language } = useParams()
	return useQuery(
		{
			queryKey: ['SportCodes', mirs_competition, mirs_language],
			queryFn: getSportsCodes,
			refetchInterval: 0,
			staleTime: Infinity,
			refetchIntervalInBackground: true,
			//notifyOnChangeProps: ['data', 'error'],
			//enabled: !!confCategory  //!! hasta que exista no se ejecuta
			onError: (error) =>
				console.error(`Something went wrong: ${error.message}`),
		});

}

export const getLiveMatches = async ({ queryKey }) => {
	// this a prototype and IT IS NOT the final solution AT ALL
	// if _date is comming, then let's supose that is the current date
	// if _date is NOT comming then let´s do the following odd 
	//  1) find for a schedule with status RUNNING or GETTING READY
	//  2) get the starDate of the above schedule
	//  3) let´s supose that the above date is the current date
	const [_key, _competition, _language, _discipline, _date, _type] = queryKey
	const url = isValidDate(_date) ?
		`${process.env.REACT_APP_SERVER_URL}/GLO_LiveMatches~comp=${_competition}~disc=${_discipline}~lang=${_language}~date=${_date}.json`
		:
		`${process.env.REACT_APP_SERVER_URL}/GLO_LiveMatches~comp=${_competition}~disc=${_discipline}~lang=${_language}.json`
	const data = await fetchData(url);

	if (data === undefined || data.schedules === undefined) {
		return []
	}

	let result = []
	// only schedules with status getting_ready or running
	result = data.schedules?.filter(i => i?.status?.code === "GETTING_READY" || i?.status?.code === "RUNNING");
	// sort by startDate
	result = result?.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

	// filter by team or individual events. 
	// this is a weak filter because it is suposed that all teams event codes contains "TEAM" string
	if (_type === 'A') {
		result = result?.filter(i => !i?.eventUnit?.code?.includes("TEAM"))
	} else {
		result = result?.filter(i => i?.eventUnit?.code?.includes("TEAM"))
	}

	// if _date is comming and it is valid, all work is done. Just filter by _date
	if (isValidDate(_date)) {
		return result?.filter(i => dateFormat(i?.startDate, undefined, "YYYY-MM-DD") === _date)
	}

	// find a schedule with status getting_ready or runnig to get "today" date
	// once today date is definded then filter scheduled with same date and status getting_ready or running
	if (result !== undefined && result.length > 0) {
		let todayDate = result[result.length - 1]?.startDate;
		return result.filter(i => {
			//console.log(`${dateFormat(i?.startDate, undefined, "YYYY-MM-DD")} === ${dateFormat(todayDate, undefined, "YYYY-MM-DD")} is ${(dateFormat(i?.startDate, undefined, "YYYY-MM-DD") === dateFormat(todayDate, undefined, "YYYY-MM-DD")) + ''}`)
			return dateFormat(i?.startDate, undefined, "YYYY-MM-DD") === dateFormat(todayDate, undefined, "YYYY-MM-DD");
		})
	}
	return []
}

export const getTodayMatches = async ({ queryKey }) => {
	// this a prototype and IT IS NOT the final solution AT ALL
	// if _date is comming, then let's supose that is the current date
	// if _date is NOT comming then let´s do the following odd 
	//  1) find for a schedule with status RUNNING or GETTING READY
	//  2) get the starDate of the above schedule
	//  3) let´s supose that the above date is the current date
	const [_key, _competition, _language, _discipline, _date, _type] = queryKey
	const url = isValidDate(_date) ?
		`${process.env.REACT_APP_SERVER_URL}/GLO_LiveMatches~comp=${_competition}~disc=${_discipline}~lang=${_language}~date=${_date}.json`
		:
		`${process.env.REACT_APP_SERVER_URL}/GLO_LiveMatches~comp=${_competition}~disc=${_discipline}~lang=${_language}.json`
	const data = await fetchData(url);

	if (data === undefined || data.schedules === undefined) {
		return []
	}

	let result = data.schedules
	// sort by startDate
	result = result?.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

	return result
}

export const getCumulativeResult = async ({ queryKey }) => {
	const [_key, _competition, _language, _rsc] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/RES_Cumulative~comp=${_competition}~lang=${_language}~rsc=${_rsc}.json`
	return await fetchData(url);
}

export const getStats = async ({ queryKey }) => {
	const [_key, _competition, _language, _rsc, _rscConfig, _type] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Stats~comp=${_competition}~lang=${_language}~rsc=${_rsc}~rscConfig=${_rscConfig}~type=${_type}.json`
	return await fetchData(url);
}

export const getScheduleByNoc = async ({ queryKey }) => {
	const [_key, _competition, _language, _noc] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_SCH_ByNOC~comp=${_competition}~lang=${_language}~noc=${_noc}.json`
	return await fetchData(url);
}

export const getMedallists = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Medallists~comp=${_competition}~lang=${_language}.json`
	return await fetchData(url);
}

export const getRecords = async ({ queryKey }) => {
	const [_key, _competition, _language, _discipline, _recordTypes] = queryKey
	const defaultRecord = isParalympic(_competition) ? process.env.REACT_APP_RECORDS_PARAS.split(",") : process.env['REACT_APP_RECORDS_' + _discipline]?.split(",");
	const recordTypes = _recordTypes || defaultRecord
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Records~comp=${_competition}~disc=${_discipline}~recordTypes=${recordTypes}~lang=${_language}.json`
	return await fetchData(url);
}

export const getPlacingsByRsc = async ({ queryKey }) => {
	const [_key, _competition, _discipline, _language] = queryKey
	//const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Placings~comp=${_competition}~disc=${_discipline}~lang=${_language?.toUpperCase()}.json`
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_PlacingsByRSC~comp=EG2023~rsc=ATHX--------D1--------------------~lang=ENG.json`
	return await fetchData(url);
}
export const getPlacingsByDiscipline = async ({ queryKey }) => {
	const [_key, _competition, _discipline, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_PlacingsBySport~comp=${_competition}~disc=${_discipline}~lang=${_language?.toUpperCase()}.json`
	return await fetchData(url);
}


export const getPdfs = async ({ queryKey }) => {
	const [_key, _competition, _code] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/CIS_Pdfs~comp=${_competition}~code=${_code?.toUpperCase()}.json`
	return await fetchData(url);
}

export const getMedal = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/CIS_MedalNOCs~comp=${_competition}~lang=${_language?.toUpperCase()}.json`
	return await fetchData(url);
}


export const getAthletes = async ({ queryKey }) => {
	const [_key, _competition, _language, _functionCategory] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/MIS_Athletes~comp=${_competition}~lang=${_language}~functionCategory=${_functionCategory}.json`
	return await fetchData(url);
}

export const getTeams = async ({ queryKey }) => {
	const [_key, _competition, _language] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/MIS_Teams~comp=${_competition}~lang=${_language}.json`
	return await fetchData(url);
}

export const getCurrentBySubcode = async ({ queryKey }) => {
	const [_key, _competition, _language, _rsc, subcode] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_CurrentBySubcode~comp=${_competition}~lang=${_language}~rsc=${_rsc}~subcode=${subcode}.json`
	return await fetchData(url);
}

export const getCommunications = async ({ queryKey }) => {
	const [_key, _competition, _discipline] = queryKey
	const url = `${process.env.REACT_APP_SERVER_URL}/GLO_Communications~comp=${_competition}~disc=${_discipline}.json`
	return await fetchData(url);
}





function addCurrentFinalSplit(data, _disc, _rsc) {

	let nodeIntermediateCurrent = "";
	let filters = "";
	let field = "";
	let nodeFinalSplit = "";
	let filtersFinalSplit = "";
	let fieldFinal = "";
	let courseSplit = "";
	let currentSplit = '';
	let finalSplit = '';
	let typeCurrent = ""; //insdica si el final es F o numero  
	let lastIntermediateArray;
	let lastIntermediate;


	if (data) {
		switch (_disc) {
			case "ATH":
				filters = {
					ei_type: ['DISPLAY'],
					ei_code: ['INTERMEDIATE_CURRENT']
				};
				filtersFinalSplit = {
					ei_type: ['UI'],
					ei_code: ['INTERMEDIATES_TOTAL']
				};
				field = 'ei_value';
				fieldFinal = 'ei_value';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				nodeFinalSplit = data?.results?.extendedInfos;
				typeCurrent = "F";
				break;
			case "DIV":
				filters = {
					ei_type: ['DISPLAY'],
					ei_code: ['CURRENT']
				};
				field = 'ei_pos';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				break;
			case "CRD":
			case "MTB":
				filters = {
					ei_type: ['LEADER'],
					ei_code: ['CURRENT']
				};
				filtersFinalSplit = {
					type: ['EC'],
					code: ['INTERMEDIATES_NUM']
				};
				field = 'ei_pos';
				fieldFinal = 'value';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				//Data from config
				nodeFinalSplit = data?.config?.extendedConfig;
				break;
			case "MPN":
				filters = {
					ei_type: ['DISPLAY'],
					ei_code: ['LEADER']
				};
				field = 'ei_pos';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				break;
			case "OWS":
				filters = {
					ei_type: ['DISPLAY'],
					ei_code: ['CURRENT_INTERMEDIATE']
				};
				filtersFinalSplit = {
					type: ['EC'],
					code: ['INTERMEDIATES_NUM']
				};
				field = 'ei_value';
				fieldFinal = 'value';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				//Data from config
				nodeFinalSplit = data?.config?.extendedConfig;
				break;
			case "SWM":
				filters = {
					ei_type: ['DISPLAY'],
					ei_code: ['LEADER']
				};
				field = 'ei_value';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				nodeFinalSplit = data?.config?.extendedConfig;
				typeCurrent = "F";
				break;
			case "TRI":
				filters = {
					ei_type: ['LEADER'],
					ei_code: ['CURRENT']
				};
				field = 'ei_value';
				//Data from extended Infos
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				nodeFinalSplit = data?.config?.extendedConfig;
				typeCurrent = "F";
				break;
			default:
				filters = {
					ei_type: ['DISPLAY'],
					ei_code: ['INTERMEDIATE_CURRENT']
				};
				filtersFinalSplit = {
					ei_type: ['UI'],
					ei_code: ['INTERMEDIATES_TOTAL']
				};
				field = 'ei_value';
				fieldFinal = 'ei_value';
				nodeIntermediateCurrent = data?.results?.extendedInfos;
				nodeFinalSplit = data?.results?.extendedInfos;
		}
		if (_disc === "TRI") {
			let conf = findArray(nodeIntermediateCurrent, filters)
			courseSplit = conf[field];
			currentSplit = findArray(conf?.extensions, { eie_code: ['INTERMEDIATE'] })?.eie_value
			finalSplit = data?.config?.extendedConfig?.filter(item => item.type === 'COURSE');
			finalSplit = finalSplit && finalSplit.length
			finalSplit = finalSplit && findArray(conf?.extensions, { eie_code: ['INTERMEDIATE'] })?.eie_value
		} else if (_disc === "MPN") {
			//Workaround:Current split se calcula numero de intermediates recorridos por el primero 
			/*
			let maxSplit = 0;
			data?.results?.items.forEach(function (item, index) {
				const intermediates = filterArray(item.extendedResults, { er_code: ['INTERMEDIATE'] })
				let max = Array.isArray(intermediates) && Math.max.apply(Math, intermediates.map(function (o) {
					return o.er_pos;
				}));
				if (max > maxSplit) { maxSplit = max }
			});
			currentSplit = maxSplit
			*/


			//last split count of nums splits in config file
			let configFilter = []  //MPNMINDIVID-----------SFNL0001LR--   //SWM[MWX]4X2+			 
			//laser		
			if (_rsc.slice(-4) === 'LR--') {  //_rsc.match("MPNMINDIVID-----------SFNL000?LR--"
				configFilter = filterArray(data?.config?.extendedConfig, { type: ['LR'], code: ['INTERMEDIATE'] });
			} else if (_rsc.slice(-4) === 'SW--') {  //_rsc.match("MPNMINDIVID-----------SFNL000?LR--"{
				configFilter = filterArray(data?.config?.extendedConfig, { type: ['SWIM'], code: ['INTERMEDIATE'] });
			}
			finalSplit = configFilter.length;

			const resultStatus = data?.results?.status?.code;
			const isFinished = isFinishedStatus(resultStatus)
			currentSplit = isFinished ? finalSplit : findArray(nodeIntermediateCurrent, filters)[field];

		} else {
			currentSplit = findArray(nodeIntermediateCurrent, filters)[field];
			//not have currentPosistion case MTT CRD
			currentSplit = (currentSplit === undefined) ? data?.results?.items?.sort((a, b) => a.sortOrder - b.sortOrder)?.find(x => x !== undefined)?.extendedResults?.find(item => item.er_type === 'ER' && item.er_code === 'CURRENT')?.er_value : currentSplit;
			//currentPosition = currentPosition === undefined ? '-1' : currentPosition;
			finalSplit = findArray(nodeFinalSplit, filtersFinalSplit)[fieldFinal];

			// si no esta la configuracion de numero de intermediates tomamos el mayor valor de intermediate
			lastIntermediateArray = data?.results?.extendedInfos?.filter(item => item?.ei_code === "INTERMEDIATE");
			if (Array.isArray(lastIntermediateArray)) {
				lastIntermediate = Math.max.apply(Math, lastIntermediateArray.map(function (item) {
					return Number(item?.ei_pos);
				}));
			}
			finalSplit = finalSplit ? finalSplit : lastIntermediate
		}


		if (typeCurrent === 'F') {
			currentSplit = (currentSplit === 'F') ? finalSplit : currentSplit; //Change F by value in order to sort splits  
		}
		currentSplit = (currentSplit === undefined) ? 1 : currentSplit;
		finalSplit = (finalSplit === undefined) ? currentSplit : finalSplit;

		(currentSplit !== undefined && finalSplit !== undefined) && data?.results?.items?.forEach((dt) => {
			if (_disc === "TRI") {
				dt.courseSplit = courseSplit === undefined ? "" : courseSplit.toString()
			}

			dt.currentSplit = currentSplit.toString();
			dt.finalSplit = typeof (finalSplit) === 'number' ? finalSplit.toString() : finalSplit
		});
	}
}